<template>
    <p :class="{ 'text-accent': product.price_min > 0 && product.price_min < product.price_max && product.price_old > product.price && $scope.IS_REGULAR_CUSTOMER }">

        <span v-if="$scope.IS_WHOLESALER || $scope.IS_SALES_REP" class="product-list-item-price">
            R${{ product.price | formatPrice }}
        </span>

        <template v-else-if="$scope.IS_REGULAR_CUSTOMER">
            <span v-if="product.price_min > 0 && product.price_min < product.price_max"
                  class="product-list-item-price">
                A partir de
                <span itemprop="priceCurrency" content="BRL">
                    R$
                </span>
                <span itemprop="price" :content="product.price_min">
                    {{ product.price_min | formatPrice }}
                </span>
            </span>

            <span v-else class="product-list-item-price">
                <span itemprop="priceCurrency" content="BRL">
                    R$
                </span>
                <span itemprop="price" :content="product.price">
                    {{ product.price | formatPrice }}
                </span>
            </span>

            <span v-if="!product.price_min && !product.price_max && product.price_old > product.price && $scope.IS_REGULAR_CUSTOMER && (options || {}).displayPercent">
                <del class="text-secondary" v-if="(options || {}).lang_iso != 'en'">
                    {{ product.price_old | formatPrice }}
                </del>
            </span>
        </template>
    </p>
</template>

<script>
    export default {
        name: "ProductCatalogPrice",

        props: {
            product: {
                type: Object,
                required: true
            },
            options: Object
        },

        filters: {
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
        },
    }
</script>